import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import "./styles/globals.css";
import AllRoutes from "./AllRoutes";
import Toast from "./common/toastPopup/Toast";

// this is v2
function App() {
  const [online, setOnline] = useState(true);

  useEffect(() => {
    if (!navigator.onLine) {
      setOnline(false);
    } else {
      setOnline(true);
    }
    window.addEventListener("offline", (e) => {
      setOnline(false);
    });

    window.addEventListener("online", (e) => {
      setOnline(true);
    });
  }, []);

  return (
    <>
      {!online && (
        <div className="z-[100] fixed right-[0px] top-[50px] w-[400px] my-[10px] mb-[30px] min-h-[45px] grid place-items-center bg-[tomato] text-[14px] font-[500] text-[white]">
          You are offline! Please check your network settings.
        </div>
      )}
      <Toast />

      {/* {All Page Router} */}
      <AllRoutes />
    </>
  );
}

export default App;
